import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './queryClient';

// Admin pages
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import TenantList from './pages/admin/TenantList';
import TenantEditor from './pages/admin/TenantEditor';

// Vendor pages
import VendorLogin from './pages/vendor/VendorLogin';
import VendorDashboard from './pages/vendor/VendorDashboard';
import Resources from './pages/vendor/Resources';
import ResourceDetails from './pages/vendor/ResourceDetails';
import Customers from './pages/vendor/Customers';
import CustomerDetails from './pages/vendor/CustomerDetails';
import SettlementOrders from './pages/vendor/SettlementOrders';
import SettlementOrderDetails from './pages/vendor/SettlementOrderDetails';
import Invoices from './pages/vendor/Invoices';
import InvoiceDetails from './pages/vendor/InvoiceDetails';
import FixedCosts from './pages/vendor/FixedCosts';
import OpenExpenses from './pages/vendor/OpenExpenses';
import News from './pages/vendor/News';
import Settings from './pages/vendor/Settings';

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        {/* One hostname for everyone: staff under /admin, vendors everywhere else */}
        <Routes>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/tenants" element={<TenantList />} />
          <Route path="/admin/tenants/new" element={<TenantEditor />} />
          <Route path="/admin/tenants/:id/edit" element={<TenantEditor />} />
          <Route path="/admin/*" element={<Navigate to="/admin/dashboard" replace />} />

          <Route path="/login" element={<VendorLogin />} />
          <Route path="/dashboard" element={<VendorDashboard />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/resources/:id" element={<ResourceDetails />} />
          <Route path="/customers" element={<Customers />} />
          <Route path="/customers/:customerNo" element={<CustomerDetails />} />
          <Route path="/settlement-orders" element={<SettlementOrders />} />
          <Route path="/settlement-orders/:id" element={<SettlementOrderDetails />} />
          <Route path="/invoices" element={<Invoices />} />
          <Route path="/invoices/:documentType/:documentNo" element={<InvoiceDetails />} />
          <Route path="/fixed-costs" element={<FixedCosts />} />
          <Route path="/open-expenses" element={<OpenExpenses />} />
          <Route path="/news" element={<News />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}

export default App;
